import React from 'react'

const Footer = () => {
    return (
        <div className="footer">
            <p>&copy;&nbsp;2022 - Elineka</p>
            
        </div>
    )
}

export default Footer
